import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'
import 'jquery-datetimepicker'

export default function user() {
  $('#user_level_ids').select2();

  $.datetimepicker.setLocale('pl');
  $('#user_birthdate').datetimepicker({
    mask: true,
    format: 'd.m.Y',
    timepicker: false,
    startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 25)),
    yearStart: new Date().getFullYear() - 100,
    yearEnd: new Date().getFullYear(),
    scrollMonth: false,
    scrollInput: false,
    dayOfWeekStart: 1
  });

  // Inicjalizacja DataTables na elemencie #rolesTable z ustawieniami językowymi
  $('#rolesTable').DataTable({
    language: {
      processing: 'Przetwarzanie...',
      search: 'Szukaj:',
      lengthMenu: 'Pokaż _MENU_ pozycji',
      info: 'Pozycje od _START_ do _END_ z _TOTAL_ łącznie',
      infoEmpty: 'Pozycji 0 z 0 dostępnych',
      infoFiltered: '(filtrowanie spośród _MAX_ dostępnych pozycji)',
      infoPostFix: '',
      loadingRecords: 'Wczytywanie...',
      zeroRecords: 'Nie znaleziono pasujących pozycji',
      emptyTable: 'Brak danych',
      paginate: {
        first: 'Pierwsza',
        previous: 'Poprzednia',
        next: 'Następna',
        last: 'Ostatnia'
      },
      aria: {
        sortAscending: ': aktywuj, by posortować kolumnę rosnąco',
        sortDescending: ': aktywuj, by posortować kolumnę malejąco'
      }
    }
  });
};
